import type { SVGProps } from "react";

export const Closeio = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="26"
    viewBox="0 0 26 26"
    width="26"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Close.io</title>
    <path
      d="M13.3714 20.3709C5.87507 20.3709 0 17.1339 0 13.0042C0 8.87457 5.87507 5.63757 13.3714 5.63757C20.8678 5.63757 26.7429 8.87457 26.7429 13.0042C26.7429 17.1339 20.8678 20.3709 13.3714 20.3709ZM13.3714 7.80424C8.03539 7.80424 2.08929 9.94057 2.08929 13.0042C2.08929 16.0679 8.03539 18.2042 13.3714 18.2042C18.7075 18.2042 24.6536 16.0679 24.6536 13.0042C24.6536 9.94057 18.7075 7.80424 13.3714 7.80424Z"
      fill="#4EC375"
    />
    <path
      d="M17.8968 25.5883C14.5456 25.5883 10.2584 22.152 7.21639 16.6876C5.49064 13.5893 4.44182 10.3176 4.25796 7.47063C4.05739 4.35063 4.91818 2.05397 6.68154 0.996635C8.44489 -0.0606981 10.7974 0.316302 13.3004 2.05397C15.5861 3.6443 17.7924 6.22263 19.5181 9.32097C23.2663 16.055 23.5003 22.9493 20.053 25.012C19.4011 25.402 18.674 25.5883 17.8926 25.5883H17.8968ZM8.87946 2.5783C8.44489 2.5783 8.05629 2.67364 7.73036 2.87297C6.70661 3.48397 6.201 5.10897 6.34307 7.32764C6.50604 9.84963 7.45875 12.792 9.02571 15.6086C11.6916 20.4013 16.451 24.674 19.0083 23.14C21.5656 21.606 20.3789 15.2013 17.7088 10.4086C16.1418 7.59197 14.1612 5.26497 12.1388 3.86097C10.927 3.0203 9.79875 2.58697 8.87529 2.58697L8.87946 2.5783Z"
      fill="#1463FF"
    />
    <path
      d="M8.87529 25.6013C8.07718 25.6013 7.34176 25.4063 6.68572 25.0119C4.92236 23.9546 4.0574 21.6579 4.26215 18.5379C4.44601 15.6909 5.49483 12.4193 7.22058 9.32092C10.9688 2.58692 16.6098 -1.07041 20.0572 0.992256C23.5045 3.05926 23.2705 9.94926 19.5223 16.6833C17.7965 19.7816 15.5903 22.3599 13.3046 23.9503C11.7334 25.0423 10.2208 25.5969 8.87529 25.5969V25.6013ZM17.8091 2.55226C15.1515 2.55226 11.3198 6.28326 9.02572 10.3999C7.45876 13.2166 6.50604 16.1546 6.34308 18.6809C6.20101 20.8996 6.70661 22.5203 7.73036 23.1356C8.75411 23.7466 10.3587 23.3913 12.1429 22.1519C14.1695 20.7436 16.146 18.4166 17.713 15.6043C20.3789 10.8116 21.5698 4.40259 19.0125 2.87292C18.6532 2.65626 18.2478 2.55659 17.8091 2.55659V2.55226Z"
      fill="#FFBC00"
    />
    <path
      d="M13.3714 18.2044C8.03539 18.2044 2.08929 16.0681 2.08929 13.0044H0C0 17.1341 5.87507 20.3711 13.3714 20.3711V18.2044Z"
      fill="#4EC375"
    />
    <path
      d="M13.852 5.26924C13.292 4.73191 12.7196 4.25524 12.1429 3.85224C11.5746 3.45791 11.0231 3.15024 10.5049 2.93791L11.1986 0.892578C11.8839 1.16558 12.59 1.55124 13.3088 2.05391C14.0651 2.58258 14.8172 3.21524 15.5443 3.94324L13.8561 5.26924H13.852Z"
      fill="#1463FF"
    />
    <path
      d="M15.5276 22.7458C14.625 22.2431 13.6848 21.4934 12.7739 20.5878L11.1735 22.0308C12.1095 22.9711 13.0706 23.7424 14.0233 24.3231L15.5317 22.7458H15.5276Z"
      fill="#1463FF"
    />
    <path
      d="M22.9989 10.3524C20.8594 8.77509 16.9775 7.80009 13.3714 7.80009V5.63342C17.5709 5.63342 21.2606 6.64742 23.6967 8.26809L22.9989 10.3524Z"
      fill="#4EC375"
    />
  </svg>
);

export default Closeio;
